// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"617c7803","127":"3c469544","237":"735d4b58","399":"482f1c05","739":"77414bb2","868":"fa9dd180","980":"f1c49944"}[chunkId] + ".chunk.js";
};